
export default function ChromeMarket() {
  const marketFacts = [
    {
      icon: 'ri-earth-line',
      title: 'Global Demand',
      description:
        'Chrome ore is mainly exported to the Asian market, especially China. International clients opt to buy directly from local sources, making small processing plants their preferred suppliers.',
    },
    {
      icon: 'ri-exchange-dollar-line',
      title: 'Currency Advantage',
      description:
        'Currency exchange rates play a massive role in selling prices, creating opportunities for competitive pricing in the international chrome market.',
    },
    {
      icon: 'ri-bar-chart-grouped-line',
      title: 'Consistent Demand',
      description:
        'Although prices fluctuate, chrome is always in demand in big tonnages — making it a very lucrative product to sell into the market.',
    },
    {
      icon: 'ri-building-2-line',
      title: 'Market Structure',
      description:
        "South Africa's mining sector is dominated by a few large mining houses that sell directly to customers in Europe, Asia and America, creating space for agile local suppliers.",
    },
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-[#8B1538] font-bold text-sm uppercase tracking-wider">
            Market Analysis
          </span>
          <h2 className="text-4xl md:text-5xl font-bold mt-3 mb-6 text-gray-900 font-montserrat">
            The Chrome Market Landscape
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            South Africa holds substantial chrome reserves contributing a significant portion to world markets
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-start">
          <div>
            <div className="bg-white rounded-lg p-8 shadow-sm mb-8">
              <h3 className="text-2xl font-bold text-gray-900 font-montserrat mb-4">
                Mineral-Rich Economy
              </h3>
              <p className="text-gray-700 leading-relaxed text-[15px] mb-4">
                The mining of commodities has contributed so much to the economy of South Africa. The country has large chrome reserves which
                contribute a substantial portion to the world markets that import huge quantities of chrome products.
              </p>
              <p className="text-gray-700 leading-relaxed text-[15px]">
                International clients also opt to rather buy the product directly from local sources; making small processing plants their
                preferred suppliers as it is cheaper to buy locally and export. This dynamic creates a significant opportunity for
                companies like TMI.
              </p>
            </div>

            <div className="bg-[#8B1538] rounded-lg p-8 text-white">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-full flex-shrink-0 mt-1">
                  <i className="ri-lightbulb-line text-2xl text-white"></i>
                </div>
                <div>
                  <h4 className="text-lg font-bold mb-2 font-montserrat">Key Insight</h4>
                  <p className="text-white/90 text-sm leading-relaxed">
                    Large mining houses do not allow clients to buy locally as it reduces their profit margins — this becomes a winning
                    opportunity for agile suppliers like TMI who can offer competitive pricing directly from source.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="grid sm:grid-cols-2 gap-6">
            {marketFacts.map((fact, index) => (
              <div
                key={index}
                className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow"
              >
                <div className="w-14 h-14 bg-gradient-to-br from-red-50 to-gray-50 rounded-full flex items-center justify-center mb-4">
                  <i className={`${fact.icon} text-2xl text-[#8B1538]`}></i>
                </div>
                <h4 className="text-base font-bold mb-2 text-gray-900 font-montserrat">
                  {fact.title}
                </h4>
                <p className="text-gray-600 text-sm leading-relaxed">{fact.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
